/* Movatic WMS — Frontend | CesarFilho 932048016 */
import CrudList from '@/components/CrudList'

// ADR-0049 F2: tela de gestão de impressoras (Printer). CrudList metadata-driven
// sobre /api/printing/printers/ (F1a). Molde da tela de Coletores (Devices.tsx).
// ADR-0050 G1 (PR-B): + colunas Código (PRN-NNN), Família (media_family) e Zona
// (process_area_label) expostas pelo serializer (PR-A).
export default function Printers() {
  return (
    <CrudList
      title="Impressoras"
      endpoint="/api/printing/printers/"
      writable
      canDelete={false}
      columns={[
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Nome' },
        { key: 'host', header: 'Host' },
        { key: 'port', header: 'Porta' },
        {
          key: 'media_family',
          header: 'Família',
          render: (r: any) =>
            r.media_family === 'DOCUMENT' ? 'Documento' : 'Etiqueta',
        },
        {
          key: 'process_area_label',
          header: 'Zona',
          render: (r: any) => r.process_area_label || '—',
        },
        {
          key: 'warehouse_label',
          header: 'Armazém',
          render: (r: any) => r.warehouse_label || '—',
        },
        {
          key: 'is_default',
          header: 'Padrão',
          render: (r: any) => (r.is_default ? 'Sim' : '—'),
        },
        {
          key: 'is_active',
          header: 'Estado',
          render: (r: any) => (r.is_active ? 'Ativo' : 'Inativo'),
        },
      ]}
    />
  )
}
